/*
* Tine 2.0
* 
* @package     HumanResources
* @license     http://www.gnu.org/licenses/agpl.html AGPL Version 3
* @author      Alexander Stintzing <a.stintzing@metaways.de>
* @copyright   Copyright (c) 2012-2013 Metaways Infosystems GmbH (http://www.metaways.de)
*/
Ext.namespace('Tine.HumanResources.Model');
